import type { IRateCalculatorIconProps } from './helpers';

export const RateCalculatorIcon = ({ variant, ...rest }: IRateCalculatorIconProps) => {
	if (variant === 'rate')
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					fill='#F7F8F8'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					stroke='#ECEEEE'
					strokeWidth='0.5'
				/>
				<g clipPath='url(#clip0_21138_221805)'>
					<path
						d='M16.375 12C16.375 14.4163 14.4163 16.375 12 16.375C9.58381 16.375 7.625 14.4163 7.625 12C7.625 9.58381 9.58381 7.625 12 7.625C14.4163 7.625 16.375 9.58381 16.375 12Z'
						fill='#2FB1CA'
					/>
					<path
						d='M12 10.6875H13.3125V9.8125H12.4375V8.9375H11.5625V9.89303C11.0546 10.0742 10.6875 10.5554 10.6875 11.125C10.6875 11.8486 11.2764 12.4375 12 12.4375C12.2415 12.4375 12.4375 12.6339 12.4375 12.875C12.4375 13.1161 12.2415 13.3125 12 13.3125H10.6875V14.1875H11.5625V15.0625H12.4375V14.1071C12.9455 13.9259 13.3125 13.4446 13.3125 12.875C13.3125 12.1513 12.7236 11.5625 12 11.5625C11.7585 11.5625 11.5625 11.3661 11.5625 11.125C11.5625 10.8839 11.7585 10.6875 12 10.6875Z'
						fill='white'
					/>
					<path
						d='M10.8231 5.98376L10.6547 5.125C7.37826 5.76587 5 8.65511 5 11.995C5 13.7892 5.70613 15.5182 6.92848 16.8075H5.875V17.6825H8.49999V15.0575H7.62499V16.2589C6.52078 15.1249 5.875 13.5919 5.875 11.995C5.875 9.07253 7.95579 6.54463 10.8231 5.98376Z'
						fill='#2FB1CA'
					/>
					<path
						d='M13.4371 5.14844L13.2578 6.00464C13.5233 6.06061 13.788 6.13452 14.0439 6.22467L14.3353 5.39955C14.0431 5.29669 13.7412 5.21231 13.4371 5.14844Z'
						fill='#2FB1CA'
					/>
					<path
						d='M11.5781 5.01272L11.631 5.88601C11.901 5.8702 12.1774 5.87202 12.4469 5.89167L12.5104 5.01881C12.2029 4.99649 11.8852 4.9935 11.5781 5.01272Z'
						fill='#2FB1CA'
					/>
					<path
						d='M9.66406 18.6058C9.95715 18.71 10.2595 18.7949 10.5631 18.8579L10.7416 18.0013C10.4769 17.9462 10.2126 17.8723 9.95715 17.7812L9.66406 18.6058Z'
						fill='#2FB1CA'
					/>
					<path
						d='M17.0739 7.1875H18.1274V6.3125H15.5024V8.93749H16.3774V7.73619C17.4816 8.8701 18.1274 10.4032 18.1274 12C18.1274 14.923 16.0467 17.4508 13.1797 18.0112L13.3473 18.8701C16.6241 18.2295 19.0024 15.3403 19.0024 12C19.0024 10.2059 18.2963 8.47682 17.0739 7.1875Z'
						fill='#2FB1CA'
					/>
					<path
						d='M11.5556 18.1094L11.4922 18.9821C11.6611 18.9944 11.8316 19.0005 12.0036 19.0005C12.1449 19.0005 12.2858 18.9965 12.4244 18.9878L12.3716 18.1146C12.1017 18.1307 11.8255 18.1295 11.5556 18.1094Z'
						fill='#2FB1CA'
					/>
				</g>
				<defs>
					<clipPath id='clip0_21138_221805'>
						<rect
							width='14'
							height='14'
							fill='white'
							transform='translate(5 5)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	if (variant === 'fee')
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					fill='#F7F8F8'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					stroke='#ECEEEE'
					strokeWidth='0.5'
				/>
				<g clipPath='url(#clip0_21138_221823)'>
					<path
						d='M14.8311 5.29244C16.9071 6.30062 18.464 8.20943 18.9941 10.5111C19.0086 10.5743 18.9661 10.6365 18.9018 10.645L15.8858 11.0439C15.832 11.051 15.7817 11.0175 15.7662 10.9655C15.4204 9.80684 14.6204 8.84449 13.5727 8.28494C13.5234 8.25859 13.5026 8.19866 13.524 8.14697L14.6814 5.34883C14.7056 5.29027 14.7741 5.26476 14.8311 5.29244Z'
						fill='#2FB1CA'
					/>
					<path
						d='M11.4624 7.75713C11.8204 7.75713 12.1686 7.79954 12.5028 7.87836C12.5551 7.89071 12.6088 7.86402 12.6293 7.81433L13.3039 6.18204C13.3291 6.12128 13.2953 6.05246 13.2321 6.03452C12.6699 5.8751 12.076 5.78906 11.4624 5.78906C7.89349 5.78906 5 8.68255 5 12.2515C5 15.8204 7.89349 18.7139 11.4624 18.7139C11.5941 18.7139 11.7248 18.7098 11.8547 18.7019C11.9183 18.698 11.9656 18.6413 11.9572 18.5781L11.7271 16.8375C11.7198 16.7819 11.6716 16.7406 11.6155 16.7425C11.5648 16.7442 11.5137 16.7451 11.4624 16.7451C8.98039 16.7451 6.96885 14.7335 6.96885 12.2515C6.96885 9.76946 8.98039 7.75713 11.4624 7.75713Z'
						fill='#2FB1CA'
					/>
					<path
						d='M17.7907 11.7588L16.0504 11.9888C15.9946 11.9962 15.9532 12.0447 15.9554 12.1009C15.9573 12.1515 15.9584 12.2024 15.9584 12.2536C15.9584 14.2887 14.6051 16.0079 12.7492 16.561C12.6979 16.5762 12.6658 16.6271 12.6728 16.6802L12.9038 18.4307C12.9124 18.4958 12.976 18.5385 13.0398 18.5225C15.8471 17.8187 17.9265 15.2788 17.9265 12.2536C17.9265 12.1219 17.9224 11.9911 17.9145 11.8613C17.9106 11.7976 17.8539 11.7504 17.7907 11.7588Z'
						fill='#2FB1CA'
					/>
					<path
						d='M13.4248 10.2985C13.3392 10.213 13.2005 10.213 13.1149 10.2985L9.50948 13.9039C9.42392 13.9895 9.42392 14.1282 9.50948 14.2138C9.55228 14.2566 9.60834 14.278 9.66442 14.278C9.72051 14.278 9.77657 14.2566 9.81936 14.2138L13.4248 10.6084C13.5103 10.5228 13.5103 10.3841 13.4248 10.2985Z'
						fill='#2FB1CA'
					/>
					<path
						d='M12.6266 12.5156C12.1346 12.5156 11.7344 12.9159 11.7344 13.4078C11.7344 13.8998 12.1346 14.3 12.6266 14.3C13.1186 14.3 13.5188 13.8998 13.5188 13.4078C13.5188 12.9159 13.1186 12.5156 12.6266 12.5156ZM12.6266 13.8618C12.3763 13.8618 12.1726 13.6582 12.1726 13.4078C12.1726 13.1575 12.3763 12.9538 12.6266 12.9538C12.8769 12.9538 13.0806 13.1575 13.0806 13.4078C13.0806 13.6582 12.8769 13.8618 12.6266 13.8618Z'
						fill='#2FB1CA'
					/>
					<path
						d='M10.3055 11.9875C10.7975 11.9875 11.1977 11.5873 11.1977 11.0953C11.1977 10.6034 10.7975 10.2031 10.3055 10.2031C9.81395 10.2031 9.41406 10.6034 9.41406 11.0953C9.41406 11.5873 9.81395 11.9875 10.3055 11.9875ZM10.3055 10.6413C10.5558 10.6413 10.7595 10.845 10.7595 11.0953C10.7595 11.3457 10.5558 11.5493 10.3055 11.5493C10.0556 11.5493 9.85227 11.3457 9.85227 11.0953C9.85227 10.845 10.0556 10.6413 10.3055 10.6413Z'
						fill='#2FB1CA'
					/>
					<path
						d='M18.9966 10.5111C18.4666 8.20942 16.9097 6.30062 14.8337 5.29244C14.7767 5.26476 14.7081 5.29027 14.6839 5.34882L14.2422 6.41676C15.9962 7.25403 17.3135 8.85867 17.7594 10.7964L18.9043 10.645C18.9687 10.6365 19.0112 10.5743 18.9966 10.5111Z'
						fill='#2FB1CA'
					/>
					<path
						d='M11.4653 6.75C8.42963 6.75 5.96875 9.21088 5.96875 12.2465C5.96875 15.2822 8.42963 17.743 11.4653 17.743C11.5941 17.743 11.7218 17.7382 11.8485 17.7295L11.73 16.8329C11.7226 16.7773 11.6744 16.736 11.6183 16.7379C11.5676 16.7396 11.5166 16.7405 11.4653 16.7405C8.98324 16.7405 6.9717 14.7289 6.9717 12.2469C6.9717 9.76488 8.98324 7.75256 11.4653 7.75256C11.8232 7.75256 12.1714 7.79496 12.5056 7.87379C12.558 7.88613 12.6116 7.85945 12.6321 7.80975L12.9824 6.96221C12.5005 6.8241 11.9916 6.75 11.4653 6.75Z'
						fill='#2FB1CA'
					/>
					<path
						d='M17.911 11.8613C17.9071 11.7976 17.8504 11.7504 17.7872 11.7588L16.9436 11.8703C16.9523 11.9968 16.9571 12.1244 16.9571 12.2532C16.9571 14.8307 15.1828 16.9935 12.7891 17.5877L12.9003 18.4307C12.9089 18.4958 12.9725 18.5385 13.0363 18.5225C15.8436 17.8187 17.923 15.2788 17.923 12.2536C17.923 12.1219 17.9189 11.9911 17.911 11.8613Z'
						fill='#2FB1CA'
					/>
				</g>
				<defs>
					<clipPath id='clip0_21138_221823'>
						<rect
							width='14'
							height='14'
							fill='white'
							transform='translate(5 5)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	if (variant === 'exchange')
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					fill='#F7F8F8'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='23.5'
					height='23.5'
					rx='11.75'
					stroke='#ECEEEE'
					strokeWidth='0.5'
				/>
				<g clipPath='url(#clip0_21138_221844)'>
					<path
						d='M18.237 7.81277L13.6746 5.05259C13.4345 4.90731 13.1278 5.08021 13.1278 5.36084V6.65477C13.1278 6.65477 12.9749 6.68003 12.7076 6.72419C11.1847 6.97586 9.72012 7.65593 8.46433 8.54033C7.37009 9.31096 6.31435 10.2738 5.5633 11.3887C5.4755 11.4815 5.47952 11.6278 5.57233 11.7156C5.6651 11.8034 5.81147 11.7994 5.89928 11.7066C5.899 11.707 5.90647 11.7009 5.91779 11.6931C6.80747 11.0803 7.78435 10.5833 8.8122 10.248C10.0536 9.84299 11.3796 9.65473 12.6803 9.82773C12.8299 9.84939 12.9794 9.87334 13.1278 9.90301V11.1969C13.1278 11.4776 13.4345 11.6505 13.6746 11.5052L18.2371 8.745C18.5874 8.53303 18.5874 8.02477 18.237 7.81277Z'
						fill='#2FB1CA'
					/>
					<path
						d='M5.76281 16.185L10.3253 18.9451C10.5654 19.0904 10.8721 18.9175 10.8721 18.6369V17.343C10.8721 17.343 11.0249 17.3177 11.2922 17.2735C12.8151 17.0219 14.2797 16.3418 15.5355 15.4574C16.6297 14.6867 17.6855 13.7239 18.4365 12.609C18.5243 12.5162 18.5203 12.3699 18.4275 12.2821C18.3347 12.1943 18.1883 12.1983 18.1005 12.2911C18.1008 12.2907 18.0933 12.2968 18.082 12.3046C17.1923 12.9174 16.2155 13.4144 15.1876 13.7497C13.9462 14.1547 12.6202 14.343 11.3195 14.17C11.1699 14.1483 11.0204 14.1244 10.872 14.0947V12.8008C10.872 12.5201 10.5653 12.3473 10.3252 12.4925L5.76281 15.2527C5.4124 15.4647 5.4124 15.973 5.76281 16.185Z'
						fill='#2FB1CA'
					/>
				</g>
				<defs>
					<clipPath id='clip0_21138_221844'>
						<rect
							width='14'
							height='14'
							fill='white'
							transform='translate(5 5)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='0.25'
				y='0.25'
				width='23.5'
				height='23.5'
				rx='11.75'
				fill='#F7F8F8'
			/>
			<rect
				x='0.25'
				y='0.25'
				width='23.5'
				height='23.5'
				rx='11.75'
				stroke='#ECEEEE'
				strokeWidth='0.5'
			/>
			<g clipPath='url(#clip0_21138_221870)'>
				<path
					d='M10.8231 5.98376L10.6547 5.125C7.37826 5.76587 5 8.65511 5 11.995C5 13.7892 5.70613 15.5182 6.92848 16.8075H5.875V17.6825H8.49999V15.0575H7.62499V16.2589C6.52078 15.1249 5.875 13.5919 5.875 11.995C5.875 9.07253 7.95579 6.54463 10.8231 5.98376Z'
					fill='#2FB1CA'
				/>
				<path
					d='M13.4371 5.14844L13.2578 6.00464C13.5233 6.06061 13.788 6.13452 14.0439 6.22467L14.3353 5.39955C14.0431 5.29669 13.7412 5.21231 13.4371 5.14844Z'
					fill='#2FB1CA'
				/>
				<path
					d='M11.5781 5.01272L11.631 5.88601C11.901 5.8702 12.1774 5.87202 12.4469 5.89167L12.5104 5.01881C12.2029 4.99649 11.8852 4.9935 11.5781 5.01272Z'
					fill='#2FB1CA'
				/>
				<path
					d='M9.66406 18.6058C9.95715 18.71 10.2595 18.7949 10.5631 18.8579L10.7416 18.0013C10.4769 17.9462 10.2126 17.8723 9.95715 17.7812L9.66406 18.6058Z'
					fill='#2FB1CA'
				/>
				<path
					d='M17.0739 7.1875H18.1274V6.3125H15.5024V8.93749H16.3774V7.73619C17.4816 8.8701 18.1274 10.4032 18.1274 12C18.1274 14.923 16.0467 17.4508 13.1797 18.0112L13.3473 18.8701C16.6241 18.2295 19.0024 15.3403 19.0024 12C19.0024 10.2059 18.2963 8.47682 17.0739 7.1875Z'
					fill='#2FB1CA'
				/>
				<path
					d='M11.5556 18.1094L11.4922 18.9821C11.6611 18.9944 11.8316 19.0005 12.0036 19.0005C12.1449 19.0005 12.2858 18.9965 12.4244 18.9878L12.3716 18.1146C12.1017 18.1307 11.8255 18.1295 11.5556 18.1094Z'
					fill='#2FB1CA'
				/>
			</g>
			<defs>
				<clipPath id='clip0_21138_221870'>
					<rect
						width='14'
						height='14'
						fill='white'
						transform='translate(5 5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
